<ng-container *transloco="let t; read: 'assignment'" >
    <h2>{{t('general')}}</h2>
    <form 
        [formGroup]="form"
        (submit)="onSubmit()"
        class="flex flexDirRow justSpaceBetween twoCol"
    >
        <kendo-formfield>
            <kendo-label [text]="t('assignmentTitle') + ' *'"></kendo-label>
            <kendo-textbox 
                formControlName="title"
            ></kendo-textbox>
            <kendo-formerror>{{t('isRequiredField')}}</kendo-formerror>
        </kendo-formfield>

        <kendo-formfield>
            <kendo-label [text]="t('internalNumber')"></kendo-label>
            <kendo-textbox 
                formControlName="internalNumber"
            ></kendo-textbox>
            <kendo-formerror *ngIf="form.get('internalNumber').hasError('required')">{{t('isRequiredField')}}</kendo-formerror>
            <kendo-formerror *ngIf="form.get('internalNumber').hasError('internalNumberExists')">{{t('internalNumberAlreadyExists')}}</kendo-formerror>
        </kendo-formfield>

        <kendo-formfield class="formfield-with-buttons">
            <kendo-label [text]="t('client') + ' *'"></kendo-label>
            <app-contact-combobox
                formControlName="client"
                class="prs"
                [valuePrimitive]="false"
            ></app-contact-combobox>
            <kendo-formerror>{{t('isRequiredField')}}</kendo-formerror>
            <a class="basic-icon mrs"
               title="Kontakt öffnen"
               [class.disabled]="form.get('client').value == null"
               (click)="openContact('client')">
                <img src="../../../assets/icons/share.svg">
            </a>
            <a class="basic-icon"
               title="In Google Maps öffnen"
               [class.disabled]="!contactHasValidAddress(form.get('client').value)"
               (click)="openGoogleMaps('client')">
                <img src="../../../assets/icons/google-maps.svg">
            </a>
        </kendo-formfield>

        <kendo-formfield>
            <kendo-label [text]="t('dueDate')"></kendo-label>
            <kendo-datepicker
                formControlName="dueDate"
                [ngClass]="dueDateClass(form.get('dueDate').value)"
            >
                <kendo-datepicker-messages
                    [today]="t('today')"
                ></kendo-datepicker-messages>
            </kendo-datepicker>
        </kendo-formfield>

        <kendo-formfield class="formfield-with-buttons">
            <kendo-label text="Ausführungsort"></kendo-label>
            <app-contact-combobox
                formControlName="executionLocation"
                class="prs"
                [valuePrimitive]="false"
            ></app-contact-combobox>
            <a class="basic-icon mrs"
               title="Kontakt öffnen"
               [class.disabled]="form.get('executionLocation').value == null"
               (click)="openContact('executionLocation')">
                <img src="../../../assets/icons/share.svg">
            </a>
            <a class="basic-icon"
               title="In Google Maps öffnen"
               [class.disabled]="!contactHasValidAddress(form.get('executionLocation').value)"
               (click)="openGoogleMaps('executionLocation')">
                <img src="../../../assets/icons/google-maps.svg">
            </a>
        </kendo-formfield>

        <kendo-formfield>
            <kendo-label [text]="t('specialNote')"></kendo-label>
            <kendo-textbox 
                formControlName="specialNote"
            ></kendo-textbox>
        </kendo-formfield>

        <kendo-formfield class="description">
            <kendo-label [text]="t('description')"></kendo-label>
            <kendo-editor
                formControlName="description"
                style="height: 300px;"
                [pasteCleanupSettings]="pasteCleanupSettings"
            >
                <kendo-toolbar>
                    <kendo-toolbar-buttongroup>
                        <kendo-toolbar-button 
                            kendoEditorBoldButton
                        ></kendo-toolbar-button>

                        <kendo-toolbar-button
                            kendoEditorItalicButton
                        ></kendo-toolbar-button>

                        <kendo-toolbar-button
                            kendoEditorUnderlineButton
                        ></kendo-toolbar-button>
                    </kendo-toolbar-buttongroup>
                    <kendo-toolbar-buttongroup>
                        <kendo-toolbar-button
                        kendoEditorInsertUnorderedListButton
                        ></kendo-toolbar-button>

                        <kendo-toolbar-button
                        kendoEditorInsertOrderedListButton
                        ></kendo-toolbar-button>
                    </kendo-toolbar-buttongroup>
                </kendo-toolbar>
            </kendo-editor>
        </kendo-formfield>

        <kendo-formfield>
            <kendo-label [for]="owner" [text]="t('owner') + ' *'"></kendo-label>
            <kendo-dropdownlist
                [data]="employees"
                [defaultItem]="defaultItem"
                textField="name"
                valueField="id"
                [valuePrimitive]="false"
                formControlName="owner"
                #owner
            >
                <ng-template kendoDropDownListItemTemplate let-dataItem>
                    {{ dataItem.firstName }} {{ dataItem.lastName }}
                  </ng-template>
                  <ng-template kendoDropDownListValueTemplate let-dataItem>
                    {{ dataItem?.firstName }} {{ dataItem?.lastName }}
                  </ng-template>
            </kendo-dropdownlist>
      
            <kendo-formerror>{{t('isRequiredField')}}</kendo-formerror>
        </kendo-formfield>

        <kendo-formfield>
            <kendo-label text="Ausführende Personen"></kendo-label>
            <kendo-multiselect
                [data]="employees"
                textField="name"
                valueField="id"
                [valuePrimitive]="true"
                formControlName="executorIds"
            >
                <ng-template kendoMultiSelectItemTemplate let-dataItem>
                    {{ dataItem.firstName }} {{ dataItem.lastName }}
                </ng-template>
                <ng-template kendoMultiSelectTagTemplate let-dataItem>
                    {{ dataItem.firstName }} {{ dataItem.lastName }}
                </ng-template>
            </kendo-multiselect>
        </kendo-formfield>

        <kendo-formfield>
            <kendo-label [text]="t('assignmentType') + ' *'"></kendo-label>
            <kendo-dropdownlist
                [data]="assignmentTypes"
                [defaultItem]="defaultItem"
                textField="name"
                valueField="id"
                [valuePrimitive]="true"
                formControlName="typeId"
            ></kendo-dropdownlist>
            <kendo-formerror>{{t('isRequiredField')}}</kendo-formerror>
        </kendo-formfield>

        <kendo-formfield *ngIf="(assignment$ | async)?.id">
            <kendo-label [text]="t('taskStatus') + ' *'"></kendo-label>
            <kendo-dropdownlist
                [data]="taskStatusArray"
                textField="name"
                valueField="id"
                [valuePrimitive]="true"
                formControlName="taskStatus"
            ></kendo-dropdownlist>
            <kendo-formerror>{{t('isRequiredField')}}</kendo-formerror>
        </kendo-formfield>
  
        <div *ngIf="canEdit">
            <button
                *permissionIf="'Permissions.Assignments.Create'"
                kendoButton
                fillMode="solid"
                size="medium"
                rounded="medium"
                themeColor="primary"
                type="submit"
                [disabled]="!form.dirty || form.invalid"
                class="mrs"
            >{{ (assignment$ | async)?.id ?  t('save') : t('create')}}
            </button>
            <ng-container *permissionIf="'Permissions.Assignments.Delete'">
                <ng-container *ngIf="assignment$ | async as assignment">
                    <button
                        kendoButton
                        fillMode="solid"
                        size="medium"
                        rounded="medium"
                        themeColor="error"
                        (click)="deletionDialogOpen()"
                        type="button">
                      {{ t('delete') }}
                    </button>

                    <app-delete-confirm-dialog
                        [(opened)]="deletionDialogOpened"
                        [message]="t('deletionMessage')"
                        (confirmed)="delete(assignment.id)"
                    ></app-delete-confirm-dialog>
                  </ng-container>
            </ng-container>
        </div>
    </form>

</ng-container>